import { createClients as createClientsBase } from '@tiny-type-api/client';
import { apis } from './universal.js';
export const createClients = (host) => createClientsBase(apis, host);
//# sourceMappingURL=client.js.map